/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import type { AnyAction } from '@reduxjs/toolkit';

/**
 * Actions that affect the entire Redux store (not just individual slices).
 */
export const enum StoreActionType {
  // This action will reset the Redux store to its uninitialized state
  // when switching from the Classic to the New IA experience (or vice
  // versa).
  // The store, however, will retain information related to the session,
  // the instance, and access control related to the instance, since
  // user authentication and instance information will remain the same
  // across experiences.
  RESET_REDUX = 'RESET_REDUX'
}

export interface ResetAction extends AnyAction {
  type: StoreActionType.RESET_REDUX;
  payload: {
    // When resetting the store, the value to set on the instance so we
    // how whether to render New IA or Classic IA.
    new_ia: boolean;
  };
}
